import styles from './DevicesHandler.module.css';

import React from 'react';
import useContextMenu from '../../../../hooks/useContextMenu';
import useOutsideClick from '../../../../hooks/useOutsideClick';
import classNames from 'classnames';
import { schemesStore } from '../../../../store/mobx/schemes.store';
import AddResourceButton from '../../SchemeButtons/AddResourceButton';
import DeviceModelAddMenu from '../../SchemeMenus/DeviceModelAddMenu';
import { SchemeModes, SchemeResourceTypes } from '../../../../consts/scheme.consts';
import { useSchemeEditorContext } from '../../SchemeEditorProvider';
import DeviceImage from '../DeviceImage';
import DeviceWrapper from 'components/DeviceWrapper';

const DevicesHandler = ({ node, mode = 'model' }) => {
  const [deviceMenuOpened, deviceMenuPosition, openDeviceMenu, closeDeviceMenu, deviceMenuRef] =
    useContextMenu();

  const { upsertSchemeNode } = schemesStore;
  const { schemeMode } = useSchemeEditorContext();

  useOutsideClick(deviceMenuRef, closeDeviceMenu);

  const handleAssignDeviceModel = async (value) => {
    await upsertSchemeNode({
      ...node,
      resources: [...node.resources, { id: value, type: SchemeResourceTypes.device_models }],
    });
  };

  const handleDeleteDeviceModel = async (deviceModel) => {
    await upsertSchemeNode({
      ...node,
      resources: [
        ...node.resources.filter(
          (resource) =>
            !(
              resource.type === SchemeResourceTypes.device_models && resource.id === deviceModel.id
            ),
        ),
      ],
    });
  };

  const DevicesIndicator = () => (
    <div className={classNames(styles.devicesIndicator)}>
      {/*<div className={styles.indicatorIcon}>*/}
      {/*  <Icon*/}
      {/*    src={settingsIcon}*/}
      {/*    color={deviceMenuOpened ? 'var(--color-brand)' : 'black'}*/}
      {/*    width={'24px'}*/}
      {/*    height={'24px'}*/}
      {/*  />*/}
      {/*</div>*/}
      {node.protocol?.device_models?.map((device, index) => (
        <DeviceWrapper mode={mode} id={device.id} key={`protocol-${device.id}-${index}`}>
          <DeviceImage
            key={index}
            handleDeleteDeviceModel={handleDeleteDeviceModel}
            item={device}
            isProtocol={true}
            schemeMode={schemeMode}
          />
        </DeviceWrapper>
      ))}
      {node.resources?.map(
        (resource, index) =>
          resource.type === SchemeResourceTypes.device_models && (
            <DeviceWrapper mode={mode} id={resource.id} key={`resource-${resource.id}-${index}`}>
              <DeviceImage
                key={index}
                handleDeleteDeviceModel={handleDeleteDeviceModel}
                item={resource}
                schemeMode={schemeMode}
              />
            </DeviceWrapper>
          ),
      )}
    </div>
  );

  return (
    <div className={styles.resourceItemContainer}>
      <DevicesIndicator />
      <div className={styles.addDeviceContainer}>
        {schemeMode === SchemeModes.edit && (
          <AddResourceButton
            classname={styles.addButton}
            title={'Добавить оборудование'}
            onClick={openDeviceMenu}
            active={deviceMenuOpened}
          ></AddResourceButton>
        )}
        {deviceMenuOpened && (
          <DeviceModelAddMenu
            ref={deviceMenuRef}
            position={{
              top: deviceMenuPosition.top,
              bottom: deviceMenuPosition.bottom,
              left: '100%',
            }}
            onSubmit={handleAssignDeviceModel}
            onClose={closeDeviceMenu}
          />
        )}
      </div>
    </div>
  );
};

export default DevicesHandler;
